import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane, faShip, faTruck } from '@fortawesome/pro-light-svg-icons';

function TransportationMethod(props) {
    const { transportationMethod, setTransportationMethod, disabled, seaLabel = 'By Sea', airLabel = 'By Air', landLabel = 'By Land', size, width, disabledMethods = [], disabledMethodsTooltip } = props;

    const options = [
        { value: 'sea', label: seaLabel, icon: faShip },
        { value: 'air', label: airLabel, icon: faPlane },
        { value: 'land', label: landLabel, icon: faTruck }
    ];

    const handleClick = (value) => {
        if (!disabled && !disabledMethods.includes(value)) {
            setTransportationMethod(value);
        }
    };

    return (
        <Box 
            sx={{ 
                width: width || '100%',
                display: 'flex',
                backgroundColor: 'rgba(241, 245, 249, 0.8)',
                borderRadius: '9999px',
                padding: '4px',
                position: 'relative',
                gap: '4px'
            }}
        >
            {options.map((option) => {
                const isSelected = transportationMethod === option.value;
                const isDisabled = disabled || disabledMethods.includes(option.value);
                const showTooltip = disabledMethods.includes(option.value) && disabledMethodsTooltip;

                const tile = (
                    <Box
                        key={option.value}
                        onClick={() => handleClick(option.value)}
                        sx={{
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            padding: '10px 20px',
                            borderRadius: '9999px',
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            position: 'relative',
                            backgroundColor: isSelected ? '#ffffff' : 'transparent',
                            border: isSelected ? '1px solid #e2e8f0' : '1px solid transparent',
                            boxShadow: isSelected ? '0 1px 3px rgba(0, 0, 0, 0.05)' : 'none',
                            transition: 'all 200ms ease-in-out',
                            opacity: isDisabled ? 0.5 : 1,
                            '&:hover': {
                                backgroundColor: !isDisabled && !isSelected ? 'rgba(241, 245, 249, 1)' : undefined,
                                '& .option-text': {
                                    color: !isDisabled && !isSelected ? '#475569' : undefined
                                },
                                '& .option-icon': {
                                    color: !isDisabled && !isSelected ? '#475569' : undefined
                                }
                            }
                        }}
                    >
                        <FontAwesomeIcon 
                            className="option-icon"
                            icon={option.icon} 
                            style={{ 
                                fontSize: '16px',
                                strokeWidth: '1.5px',
                                color: isSelected ? '#0f172a' : '#64748b',
                                transition: 'color 200ms ease-in-out'
                            }} 
                        />
                        <Typography
                            className="option-text"
                            variant={size === 'small' ? 'caption' : 'body2'}
                            sx={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: size === 'small' ? '12px' : '14px',
                                letterSpacing: '-0.01em',
                                color: isSelected ? '#0f172a' : '#64748b',
                                whiteSpace: 'nowrap',
                                transition: 'color 200ms ease-in-out'
                            }}
                        >
                            {option.label}
                        </Typography>
                    </Box>
                );
                return showTooltip
                    ? <Tooltip key={option.value} title={disabledMethodsTooltip} arrow><Box sx={{ flex: 1, display: 'flex' }}>{tile}</Box></Tooltip>
                    : tile;
            })}
        </Box>
    );
}

export default TransportationMethod;
